import clueReport from './clueReport'
export default clueReport
